module.exports = __webpack_public_path__ + "assets/img/information.9d7b0c29.png";